import { browserHistory } from 'react-router';
import {
  getTemplates,
  getTemplate,
  getEvent,
  getRemainingOffers,
  GET_REMAINING_OFFERS,
} from '../../../api/ApiManager';
import {
  getZonesWithDeletedOffers,
  mergeZoneOffers,
} from '../common/helpers/index';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import { UPDATE_NOTIFICATION } from '../../../store/app';
import cloneDeep from 'lodash/cloneDeep';
import { defaultFilterConfiguration } from '../../../common/components/filter/Filters.constants';
export const LOAD_TEMPLATES_BEGIN = 'LOAD_TEMPLATES_BEGIN';
export const LOAD_TEMPLATES_SUCCESS = 'LOAD_TEMPLATES_SUCCESS';
export const LOAD_TEMPLATES_FAILURE = 'LOAD_TEMPLATES_FAILURE';
export const LOAD_TEMPLATE_CHRON_PAGE = 'LOAD_TEMPLATE_CHRON_PAGE';
export const FETCH_TEMPLATE_BASE_EVENT_BEGIN =
  'FETCH_TEMPLATE_BASE_EVENT_BEGIN';
export const FETCH_TEMPLATE_BASE_EVENT_SUCCESS =
  'FETCH_TEMPLATE_BASE_EVENT_SUCCESS';
export const FETCH_TEMPLATE_BASE_EVENT_FAILURE =
  'FETCH_TEMPLATE_BASE_EVENT_FAILURE';
export const SORT_TEMPLATE_CHRON = 'SORT_TEMPLATE_CHRON';
export const FILTER_TEMPLATE_CHRON = 'FILTER_TEMPLATE_CHRON';
export const FETCH_TEMPLATE_EDIT_DATA = 'FETCH_TEMPLATE_EDIT_DATA';
export const FETCH_TEMPLATE_EDIT_DATA_BEGIN = 'FETCH_TEMPLATE_EDIT_DATA_BEGIN';
export const FETCH_TEMPLATE_EDIT_DATA_SUCCESS =
  'FETCH_TEMPLATE_EDIT_DATA_SUCCESS';
export const FETCH_TEMPLATE_EDIT_DATA_FAILURE =
  'FETCH_TEMPLATE_EDIT_DATA_FAILURE';
export const DIRECT_TO_EDIT_TEMPLATE = 'DIRECT_TO_EDIT_TEMPLATE';
export const REDIRECT_TO_CREATE_TEMPLATE = 'REDIRECT_TO_CREATE_TEMPLATE';
export const GET_REMAINING_OFFERS_BEGIN = 'GET_REMAINING_OFFERS_BEGIN';
export const GET_REMAINING_OFFERS_SUCCESS = 'GET_REMAINING_OFFERS_SUCCESS';
export const GET_REMAINING_OFFERS_FAILURE = 'GET_REMAINING_OFFERS_FAILURE';

export const fetchTemplateBaseEventBegin = () => {
  return {
    type: FETCH_TEMPLATE_BASE_EVENT_BEGIN,
  };
};
export const fetchTemplateBaseEventSuccess = (event) => {
  return {
    type: FETCH_TEMPLATE_BASE_EVENT_SUCCESS,
    event,
  };
};
export const fetchTemplateBaseEventFailure = (error) => {
  return {
    type: FETCH_TEMPLATE_BASE_EVENT_FAILURE,
    error,
  };
};

export const getRemainingOffersBegin = () => {
  return { type: GET_REMAINING_OFFERS_BEGIN };
};

export const getRemainingOffersSuccess = (zones, template) => {
  return { type: GET_REMAINING_OFFERS_SUCCESS, zones, template };
};

export const getRemainingOffersFailure = (err) => {
  return { type: GET_REMAINING_OFFERS_FAILURE, err };
};

export const loadTemplatesStarted = () => {
  return { type: LOAD_TEMPLATES_BEGIN };
};

export const templatesLoadedSuccess = (templates) => {
  return { type: LOAD_TEMPLATES_SUCCESS, templates };
};

export const loadTemplatesFailure = (failureMessage) => {
  return { type: LOAD_TEMPLATES_FAILURE, failureMessage };
};

export const loadTemplateChronPage = (page) => {
  return { type: LOAD_TEMPLATE_CHRON_PAGE, page };
};

export const sortTemplateChron = (column) => {
  return { type: SORT_TEMPLATE_CHRON, column };
};

export const filterTemplateChron = (filterConfiguration) => {
  return { type: FILTER_TEMPLATE_CHRON, filterConfiguration };
};

export const redirectToCreateTemplate = () => {
  browserHistory.push('/templates/create');
  return { type: REDIRECT_TO_CREATE_TEMPLATE };
};
export const directToEditTemplate = (templateId) => {
  browserHistory.push(`/templates/${templateId}/edit`);
  return {
    type: DIRECT_TO_EDIT_TEMPLATE,
  };
};

export const fetchTemplateEditDataBegin = () => {
  return {
    type: FETCH_TEMPLATE_EDIT_DATA_BEGIN,
  };
};

export const fetchTemplateEditDataSuccess = (template) => {
  return {
    type: FETCH_TEMPLATE_EDIT_DATA_SUCCESS,
    template,
  };
};

export const fetchTemplateEditDataFailure = (error) => {
  return {
    type: FETCH_TEMPLATE_EDIT_DATA_FAILURE,
    error,
  };
};

export const updateNotifications = (message, status, dismissable) => {
  return {
    type: UPDATE_NOTIFICATION,
    message,
    status,
    dismissable,
  };
};

//////////////////////
////// ASYNC
//////////////////////
export const fetchTemplateEditData = (id) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(fetchTemplateEditDataBegin());
    return getTemplate(contextId, id)
      .then((response) => {
        const success = response.data.ResponseStatus.Message === 'Success';
        if (success) {
          const found = cloneDeep(response.data.Templates[0]);
          const templateData = camelcaseKeysDeep(found);
          const eventId = templateData.eventId;
          dispatch(fetchTemplateBaseEventBegin());
          getEvent(contextId, eventId).then((response) => {
            const noError = response.data.hasOwnProperty('Event');
            if (noError) {
              const baseEventData = cloneDeep(response.data.Event);
              const event = camelcaseKeysDeep(baseEventData);
              dispatch(fetchTemplateBaseEventSuccess(event));
            }
          });
          dispatch(fetchTemplateEditDataSuccess(templateData));
          dispatch(directToEditTemplate(id));
        } else {
          dispatch(fetchTemplateEditDataFailure());
        }
      })
      .catch((error) => {
        dispatch(fetchTemplateEditDataFailure(error));
      });
  };
};
export const loadTemplates = () => {
  return (dispatch, getState) => {
    dispatch(loadTemplatesStarted());
    const contextId = getState().app.contextId;
    getTemplates(contextId)
      .then((response) => {
        const success =
          response.data.Templates && response.data.Templates.length > 0;

        if (success) {
          const formatTemplates = camelcaseKeysDeep(response.data.Templates);
          const templates = formatTemplates.map((temp, i) => {
            //todo remove mock deactivation field
            const axsVenueId = temp.aXSVenueId;
            delete temp.aXSVenueId;
            return Object.assign({}, temp, { axsVenueId });
          });
          dispatch(templatesLoadedSuccess(templates));
          dispatch(filterTemplateChron(defaultFilterConfiguration));
        } else if (
          response.data.Templates &&
          response.data.Templates.length === 0
        ) {
          dispatch(
            updateNotifications(
              'No templates exist for this context.',
              'warning',
              true
            )
          );
          dispatch(templatesLoadedSuccess([]));
        } else {
          dispatch(
            updateNotifications('Failed to fetch any templates.', 'error', true)
          );
          dispatch(loadTemplatesFailure('Failed to fetch templates.'));
        }
      })
      .catch((err) => {
        dispatch(loadTemplatesFailure(err));
        dispatch(updateNotifications('Error fetching templates', 'error'));
        setTimeout(() => {
          dispatch({ type: 'HIDE_NOTIFICATION' });
        }, 8000);
      });
  };
};

export const getTemplateRemainingOffersList = (
  templateId,
  eventId,
  templateData
) => {
  return (dispatch, getState) => {
    dispatch(getRemainingOffersBegin());
    const contextId = getState().app.contextId;
    const currentLinkedZones = getState().template_form.linkedZones;
    const recoveredOffersList = getZonesWithDeletedOffers(currentLinkedZones);
    getRemainingOffers(contextId, eventId, templateId)
      .then((response) => {
        if (response.data.hasOwnProperty('Zones')) {
          if (response.data.Zones.length) {
            const receivedZones = camelcaseKeysDeep(response.data.Zones);
            const mergedZones = mergeZoneOffers(
              recoveredOffersList,
              receivedZones
            );
            dispatch(getRemainingOffersSuccess(mergedZones, templateData));
          } else if (response.data.Zones && response.data.Zones.length === 0) {
            if (recoveredOffersList.length > 0) {
              dispatch(
                getRemainingOffersSuccess(recoveredOffersList, templateData)
              );
            } else {
              dispatch(
                updateNotifications(
                  'No more associated offers for the template',
                  'warning',
                  true
                )
              );
              dispatch(
                getRemainingOffersFailure(
                  'No more associated offers for the template'
                )
              );
              setTimeout(() => {
                dispatch({ type: 'HIDE_NOTIFICATION' });
              }, 4000);
            }
          }
        } else {
          dispatch(getRemainingOffersFailure('Failed to fetch new offers'));
        }
      })
      .catch((err) => {
        dispatch(getRemainingOffersFailure(err));
        dispatch(updateNotifications('Error fetching new offers', 'error'));
        setTimeout(() => {
          dispatch({ type: 'HIDE_NOTIFICATION' });
        }, 8000);
      });
  };
};

const ACTION_HANDLERS = {
  [LOAD_TEMPLATES_BEGIN]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },

  [LOAD_TEMPLATES_SUCCESS]: (state, action) => {
    const processedTemplates = action.templates.map((template) => {
      const category =
        template.categories.length >= 1 ? template.categories[0].name : '';
      template.category = category;
      template.numZones = 1;
      return template;
    });
    return Object.assign({}, state, {
      templates: processedTemplates,
      filteredTemplates: action.templates,
      isLoading: false,
      lastFetched: new Date(),
    });
  },
  [LOAD_TEMPLATES_FAILURE]: (state, action) => {
    return Object.assign({}, state, {
      error: action.failureMessage,
      isLoading: false,
    });
  },
  [LOAD_TEMPLATE_CHRON_PAGE]: (state, action) => {
    return Object.assign({}, state, { currentPage: action.page });
  },
  [SORT_TEMPLATE_CHRON]: (state, action) => {
    const sortDir =
      action.column === state.sortByColumn
        ? state.sortDir === 'ASC'
          ? 'DESC'
          : 'ASC'
        : state.sortDir;

    return Object.assign({}, state, {
      sortByColumn: action.column,
      sortDir: sortDir,
      currentPage: 0,
    });
  },
  [FILTER_TEMPLATE_CHRON]: (state, action) => {
    const {
      filterConfiguration: { isActive, isDeactivated, keyword },
    } = action;

    const filteredTemplates = JSON.parse(JSON.stringify(state.templates))
      .filter((template) => {
        return (
          template.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1
        );
      })
      .filter((template) => {
        if (isActive && isDeactivated) {
          return true;
        }
        if (!isActive && !isDeactivated) {
          return false;
        }
        return (
          !!template.isActive === isActive ||
          !!template.isActive === !isDeactivated
        );
      });

    return Object.assign({}, state, {
      filteredTemplates,
      filterText: action.filterText,
      currentPage: 0,
    });
  },
  [FETCH_TEMPLATE_EDIT_DATA_BEGIN]: (state) => {
    return Object.assign({}, state);
  },
  [FETCH_TEMPLATE_EDIT_DATA_SUCCESS]: (state) => {
    return Object.assign({}, state);
  },
  [FETCH_TEMPLATE_EDIT_DATA_FAILURE]: (state, action) => {
    return Object.assign({}, state, { error: action.error });
  },
  [REDIRECT_TO_CREATE_TEMPLATE]: (state) => {
    return Object.assign({}, state, {});
  },
  [DIRECT_TO_EDIT_TEMPLATE]: (state) => {
    return Object.assign({}, state);
  },
  [FETCH_TEMPLATE_BASE_EVENT_BEGIN]: (state) => {
    return Object.assign({}, state);
  },
  [FETCH_TEMPLATE_BASE_EVENT_SUCCESS]: (state) => {
    return Object.assign({}, state, {});
  },
  [FETCH_TEMPLATE_BASE_EVENT_FAILURE]: (state, action) => {
    return Object.assign({}, state, { error: action.error });
  },
  [GET_REMAINING_OFFERS_BEGIN]: (state) => {
    return Object.assign({}, state);
  },
  [GET_REMAINING_OFFERS_SUCCESS]: (state) => {
    return Object.assign({}, state, {});
  },
  [GET_REMAINING_OFFERS_FAILURE]: (state, action) => {
    return Object.assign({}, state, { error: action.error });
  },
};

export const initialState = {
  error: '',
  lastTouchedTemplate: '',
  lastTouchedTemplateState: '',
  lastFetched: null,
  isLoading: false,
  sortDir: 'ASC',
  sortByColumn: 'name',
  filterText: '',
  currentPage: 0,
  entriesPerPage: 50,
  templates: [],
  filteredTemplates: [],
};

export default function chronReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/Templates/modules/templateChron.js